import {
  MessageCircle,
  BriefcaseMedical,
  Hospital,
  GaugeCircle,
  Calendar,
  Car,
  Users,
  FileText,
} from "lucide-react"

import { Link } from "react-router-dom"
import { useSelector } from "react-redux"

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

// Menu items.
const items = [
  {
    title: "Dashboard",
    url: "/",
    icon: GaugeCircle,
  },
  {
    title: "Chats",
    url: "/chats",
    icon: MessageCircle,
  },
  {
    title: "Appointments",
    url: "/appointments",
    icon: Calendar,
  },
  // {
  //   title: "Cab Bookings",
  //   url: "/cab-bookings",
  //   icon: Car,
  // },
  {
    title: "Patients Info",
    url: "/patients",
    icon: FileText,
  },
]

const services = [
  {
    title: "Services",
    url: "/services",
    icon: Hospital,
  },
  {
    title: "Doctors",
    url: "/doctors",
    icon: BriefcaseMedical,
  },
]

export default function AppSidebar() {
  const { userRole } = useSelector((state) => state.user)

  // Add User Management only for admin users
  const getServiceItems = () => {
    if (userRole === "ADMIN") {
      return [
        ...services,
        {
          title: "User Management",
          url: "/user-management",
          icon: Users,
        },
      ]
    }
    return services
  }

  return (
    <Sidebar collapsible="icon">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Medical Bot</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <Link to={item.url}>
                      <item.icon />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        <SidebarGroup>
          <SidebarGroupLabel>Services and Medical Experts</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {getServiceItems().map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <Link to={item.url}>
                      <item.icon />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
